import { $authHost, $host } from ".."

export const loginAPI = async ({ email, password }) => {
    const {data} = await $host.post('api/users/login', {email, password})
    return data
}

export const authAPI = async () => {
    const {data} = await $authHost.get('api/users/auth/', {withCredentials: true})
    return data
}

export const logoutAPI = async () => {
    const {data} = await $authHost.get('api/users/logout/', {withCredentials: true})
    return data
}

export const getUserSettingsAPI = async () => {
    const {data} = await $authHost.get('api/users/settings/')
    return data
}

export const editUserSettingsAPI = async (settings) => {
    const {data} = await $authHost.post('api/users/settings/', settings)
    return data
}

export const getSupplierUsersAPI = async () => {
    const {data} = await $authHost.get('api/users/suppliers/')
    return data
}